import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { WorkspaceRecovery } from './components/WorkspaceRecovery';
import './styles.css';
import './luxury.css';
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WorkspaceRecovery>
      <App />
    </WorkspaceRecovery>
  </React.StrictMode>,
);
